import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "components/sidebar/Sidebar";
import Header from "components/Header";
import ActiveUserNavbar from "components/ActiveUserNavbar";
import AdminSidebar from "components/sidebar/AdminSidebar";
import { useAuth } from "context/AuthContext";
// import Header from "components/header/Header";

type Props = {
  children: ReactNode;
};

const DashboardLayout: React.FC<Props> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const shouldRenderSidebar = location.pathname !== "/error";
  const shouldRenderHeader = location.pathname !== "";
  const sectionClassName =
    location.pathname === "/error"
      ? "h-[100vh]"
      : "w-[100%] md:screen-container h-[100vh] ";

  return (
    <main className="w-[100vw] h-auto flex overflow-hidden">
      {shouldRenderSidebar && (
        <aside className="hidden md:block">
          {user?.role === "admin" ? (
            <AdminSidebar />
          ) : user?.role === "developer" || user?.role === "owner" ? (
            <Sidebar />
          ) : null}
        </aside>
      )}

      <div>
        <Header />
        <ActiveUserNavbar />
      </div>
      <section className={`${sectionClassName} overflow-y-auto  `}>
        {children}
      </section>
    </main>
  );
};

export default DashboardLayout;
